import Glide from "@glidejs/glide";
import responsiveNav from "./components/responsive-nav";
import dropdownMenu from "./components/dropdownmenu";
import chevronSlider from "./components/chevron-slider";
import modal from "./components/modal";
import parallaxScroll from "./components/parallaxScroll";
import headerScroll from "./components/header-scroll";
import { initShowMorePosts } from "./components/ShowMorePosts.js";
import "./components/controlCollapse.js";
import bannerClose from "./components/banner.js";
import "./components/display-article-video.js";
import "./components/resource-filter.js";
import initializePlanBlock from "./components/plan-details";
import subhero_close from "./components/subhero_close";
import "./components/search-toggle.js";
import "./components/category-nav.js";

//Close functionality for subhero
subhero_close();

//Plan Details block logic
initializePlanBlock();

//Banner close functionality
bannerClose();

//Header scroll add class
headerScroll();

//dropdown menu
dropdownMenu();

// Modal functionality
modal();

//Responsive Nav
responsiveNav();

//Chevron slider
chevronSlider();

//Parallax
parallaxScroll();

// Expandsets
let expandsets = document.querySelectorAll("[data-expandset]");
// dynamically load Expandset
if (expandsets.length) {
	import(/* webpackChunkName: "expandset" */ "./lib/Expandset").then(
		({ default: Expandset }) => {
			expandsets.forEach((expandset) => {
				new Expandset(expandset, {
					accordion: true,
				});
			});
		}
	);
}

if (document.querySelector(".glide")) {
	new Glide(".glide", {
		type: "carousel",
		startAt: 0,
		perView: 1,
		autoplay: 7000,
		hoverpause: true,
	}).mount();
}

/* init post show more button */
initShowMorePosts();
